import React from 'react'

export const ivrBlockingSVG = <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px" 
width="24px" height="24px" viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve">
<g className="ivrSign">
<g>
   <rect id="cuadro1" x="2.5" y="16" width="5" height="5"/>
   <rect id="cuadro2" x="9.5" y="16" width="5" height="5"/>
   <rect id="cuadro3" x="16.5" y="16" width="5" height="5"/>
</g>
<polygon points="5.8,9.3 11.2,9.3 11.2,14 12.8,14 12.8,9.3 18.2,9.3 18.2,14 19.8,14 19.8,7.7 12.8,7.7 12.8,3 11.2,3 11.2,7.7 4.2,7.7 4.2,14 5.8,14 "/>
</g>
</svg>


// WEBPACK FOOTER //
// ./src/Images/IVRSVG.js